/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/SearchBar/Content/No"
  
}) {
let referralTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'referral',
path: 'template.id',
})
let constantData = 'Professional'
let aggregateData = fromAggregate.equals(referralTemplateIdValueData, constantData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="No.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 textAlign="center"
 text={aggregateData ? "Type at least first 3 characters of the professional name" : "Type at least first 3 characters of the patient name"}
 data="referral.template.id"
 data="'Professional'"
 aggregate="/Data/aggregate.js equals"
/>
</div>
{children}
</React.Fragment>)
}